import { FC } from 'react';
import { useWhatsappTemplates } from '../../../hooks/useWhatsappTemplates';
import { WhatsappTemplateWabaSection } from '../WhatsappTemplateWabaSection';
import { WhatsappTemplateListContent } from './WhatsappTemplateListContent';
import { WhatsappTemplateListControls } from './WhatsappTemplateListControls';
import { WhatsappTemplateListEmptyState } from './WhatsappTemplateListEmptyState';
import { WhatsappTemplateListHeader } from './WhatsappTemplateListHeader';
import { WhatsappTemplateListLoadingState } from './WhatsappTemplateListLoadingState';
import { useWhatsappTemplateListActions } from './useWhatsappTemplateListActions';
import { useWhatsappTemplateListFilters } from './useWhatsappTemplateListFilters';
import { useWhatsappWabaSelection } from './useWhatsappWabaSelection';

export const WhatsappTemplateList: FC = () => {
  const { wabaAccounts, getTemplatesForWaba, isLoading } = useWhatsappTemplates();
  const { selectedWabaId, setSelectedWabaId, selectedWabaTemplates } = useWhatsappWabaSelection({ wabaAccounts, getTemplatesForWaba });
  const { handleCreate, handleEdit, handleRequestDelete, handleTemplatesHubEdit } = useWhatsappTemplateListActions();

  const { selectedFilter, setSelectedFilter, viewMode, setViewMode, searchValue, setSearchValue, filteredItems, templateFilters } =
    useWhatsappTemplateListFilters(selectedWabaTemplates);

  return (
    <section className='space-y-5 bg-surface'>
      <WhatsappTemplateListHeader onCreate={handleCreate} />

      <WhatsappTemplateWabaSection
        accounts={wabaAccounts}
        selectedWabaId={selectedWabaId}
        onWabaChange={setSelectedWabaId}
        templates={selectedWabaTemplates}
        isLoading={isLoading}
      />

      {isLoading ? <WhatsappTemplateListLoadingState /> : null}

      {!isLoading ? (
        <>
          {selectedWabaTemplates.length > 0 ? (
            <WhatsappTemplateListControls
              templateFilters={templateFilters}
              selectedFilter={selectedFilter}
              onFilterChange={setSelectedFilter}
              searchValue={searchValue}
              onSearchChange={setSearchValue}
              viewMode={viewMode}
              onViewModeChange={setViewMode}
              filteredCount={filteredItems.length}
              totalCount={selectedWabaTemplates.length}
              onEditHub={() => handleTemplatesHubEdit('edit')}
              onDeleteHub={() => handleTemplatesHubEdit('delete')}
            />
          ) : null}

          {filteredItems.length > 0 ? (
            <WhatsappTemplateListContent viewMode={viewMode} items={filteredItems} onEdit={handleEdit} onRequestDelete={handleRequestDelete} />
          ) : (
            <WhatsappTemplateListEmptyState
              variant={selectedWabaTemplates.length === 0 ? 'global' : 'filtered'}
              onCreate={selectedWabaTemplates.length === 0 ? handleCreate : undefined}
            />
          )}
        </>
      ) : null}
    </section>
  );
};
